/**
 * @param {{ title: string, link: string, image: string, date: string, city: undefined|string }[]} items
 * @param {number} autoplayDelay
 */
export default function EventsSlider({ items, autoplayDelay = 6000 }) {
    
    const sliderRef = React.useRef()
    const swiperRef = React.useRef()
    
    React.useEffect(() => {
        if (sliderRef.current) {
            const params = items.length > 1
                ? {loop: true, autoplay: {delay: autoplayDelay, disableOnInteraction: true, pauseOnMouseEnter: true}}
                : {}
            
            swiperRef.current = new Swiper(sliderRef.current, params);
        }
        
        return () => {
            if (swiperRef.current) {
                swiperRef.current.destroy()
                swiperRef.current = null
            }
        }
    }, [ items, autoplayDelay ])

    if (items.length === 0)
        return null
    
    return <div className="event-card__slider">
        <div ref={sliderRef} className="swiper">
            <div className="swiper-wrapper">
                {items.map(({link, image, title, date, city}, index) => {
                    return <div key={`event-${index}`} className={'swiper-slide'}>
                        <div className={'event-card'}>
                            <a href={link} className="event-card__link" target='_blank'></a>
                            <div className="event-card__img">
                                <img width={260} height={160} src={image || ''} alt=""/>
                            </div>
                            <div className="event-card__title">
                                <div>
                                    <h3>{title}</h3>
                                    <span>{date}{!!city && `, ${city}`}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </div>
    </div>
}